import { type App } from 'vue';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

// Export the
export type { AdminAccessControlGlobalOptions };
export { default as routes } from './routes';

// Import the global options.
import { type AdminAccessControlGlobalOptions } from './options';

// Import/Export the components that you want to use outside of this library.
import LicenseBadge from './components/LicenseBadge.vue';

export { LicenseBadge };

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                TeamsCountPanel: () => import('./partials/TeamsCountPanel.vue'),
                UsersCountPanel: () => import('./partials/UsersCountPanel.vue'),
                TeamDetails: () => import('./partials/TeamDetails.vue'),
                UserExpandDisplay: () =>
                    import('./partials/UserExpandDisplay.vue'),
                TeamUsers: () => import('./partials/TeamUsers.vue'),
                CreateTeam: () => import('./partials/CreateTeam.vue'),
                UpdateTeam: () => import('./partials/UpdateTeam.vue'),
                CreateUser: () => import('./partials/CreateUser.vue'),
                UpdateUser: () => import('./partials/UpdateUser.vue'),
                UserDetails: () => import('./partials/UserDetails.vue'),
                UserTeams: () => import('./partials/UserTeams.vue'),
                AddUserTeam: () => import('./partials/AddUserTeam.vue'),
                EditTeamRole: () => import('./partials/EditTeamRole.vue'),
                CreateContact: () => import('./partials/CreateContact.vue'),
                InvitesPanel: () => import('./partials/InvitesPanel.vue'),
                LicensesPanel: () => import('./partials/LicensesPanel.vue'),
                UserAssignTeam: () => import('./partials/UserAssignTeam.vue'),
                UserAssignUserRole: () =>
                    import('./partials/UserAssignUserRole.vue'),
                TeamAssignCompany: () =>
                    import('./partials/TeamAssignCompany.vue'),
                TeamLicenses: () => import('./partials/TeamLicenses.vue'),
                ContactAssignCompany: () =>
                    import('./partials/ContactAssignCompany.vue'),
                TeamAssignUsers: () => import('./partials/TeamAssignUsers.vue'),
                InviteUser: () => import('./partials/InviteUser.vue'),
                ContactInvites: () => import('./partials/ContactInvites.vue'),
                ContactDetails: () => import('./partials/ContactDetails.vue'),
                EditUserInvite: () => import('./partials/EditUserInvite.vue'),
                ManageLicenses: () => import('./partials/ManageLicenses.vue'),
                CreateTeamLicenseClass: () =>
                    import('./partials/CreateTeamLicenseClass.vue'),
                AssignLicenseTeam: () =>
                    import('./partials/AssignLicenseTeam.vue'),
                ContactUsers: () => import('./partials/ContactUsers.vue'),
                RolesTable: () => import('./partials/RolesTable.vue'),
                ContactAccountDisplay: () =>
                    import('./partials/ContactAccountDisplay.vue'),
            },
            '@precon-tools-suite-by-shared/admin-access-control-feature/partials/'
        );
    },
};
